'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var clsx = require('clsx');
var nthHookTheme = require('@narvar/nth-hook-theme');
var SelectItem_module = require('./SelectItem.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var clsx__default = /*#__PURE__*/_interopDefaultLegacy(clsx);

const SelectItem = _ref => {
  let {
    onClick,
    selected,
    readOnly,
    disabled,
    borderless,
    transparent,
    customStyle,
    children
  } = _ref;
  const {
    documentbodyNoneNone,
    bodytextDefaultNone,
    panelcontainerNoneNone,
    selecteditemNoneNone,
    buttonsSecondaryDisabled
  } = nthHookTheme.useTheme();
  const [hover, setHover] = React.useState(false);
  const classes = clsx__default["default"]({
    [SelectItem_module["default"].selectItem]: true,
    [SelectItem_module["default"].hoverBorder]: !selected && !readOnly && !disabled && !borderless,
    [SelectItem_module["default"].noBorder]: borderless
  });
  const defaultBackgroundColor = (documentbodyNoneNone === null || documentbodyNoneNone === void 0 ? void 0 : documentbodyNoneNone.backgroundColor) ?? (panelcontainerNoneNone === null || panelcontainerNoneNone === void 0 ? void 0 : panelcontainerNoneNone.backgroundColor);
  const borderStyle = {
    borderTopColor: (selecteditemNoneNone === null || selecteditemNoneNone === void 0 ? void 0 : selecteditemNoneNone.borderTopColor) ?? '#000',
    borderLeftColor: (selecteditemNoneNone === null || selecteditemNoneNone === void 0 ? void 0 : selecteditemNoneNone.borderLeftColor) ?? '#000',
    borderRightColor: (selecteditemNoneNone === null || selecteditemNoneNone === void 0 ? void 0 : selecteditemNoneNone.borderRightColor) ?? '#000',
    borderBottomColor: (selecteditemNoneNone === null || selecteditemNoneNone === void 0 ? void 0 : selecteditemNoneNone.borderBottomColor) ?? '#000'
  };
  return /*#__PURE__*/React__default["default"].createElement("button", {
    className: classes,
    style: {
      ...bodytextDefaultNone,
      ...customStyle,
      ...(hover && !selected && !readOnly && !disabled && !borderless && borderStyle),
      ...(hover && !selected && !readOnly && !disabled && !transparent && {
        backgroundColor: defaultBackgroundColor ?? 'rgba(0, 0, 0, 0.05)',
        filter: defaultBackgroundColor ? 'brightness(95%)' : undefined
      }),
      ...(selected && !borderless && {
        borderWidth: '2px',
        borderStyle: 'solid',
        ...borderStyle
      }),
      ...(selected && {
        backgroundColor: !transparent ? (selecteditemNoneNone === null || selecteditemNoneNone === void 0 ? void 0 : selecteditemNoneNone.backgroundColor) ?? defaultBackgroundColor : undefined
      }),
      ...(readOnly && {
        cursor: 'inherit'
      }),
      ...(disabled && {
        cursor: 'not-allowed',
        color: (buttonsSecondaryDisabled === null || buttonsSecondaryDisabled === void 0 ? void 0 : buttonsSecondaryDisabled.color) ?? '#999'
      }),
      ...(transparent && {
        background: 'inherit'
      }),
      ...(borderless && {
        border: 'none'
      })
    },
    onClick: readOnly || disabled ? undefined : onClick,
    onMouseEnter: () => setHover(!hover),
    onMouseLeave: () => setHover(!hover)
  }, children);
};
var SelectItem$1 = nthHookTheme.withThemeProvider(SelectItem, {
  themeTokens: ['documentbodyNoneNone', 'bodytextDefaultNone', 'panelcontainerNoneNone', 'selecteditemNoneNone', 'buttonsSecondaryDisabled']
});

exports["default"] = SelectItem$1;
